import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {DashboardWrapper} from '../../../../../app/pages/dashboard/DashboardWrapper'
import Jobs from '../../../../../app/modules/profile/components-company/Jobs'
import CreateJob from '../../../../../app/modules/profile/components-company/Jobs/Create'
import Applicants from '../../../../../app/modules/profile/components-company/Jobs/Applicants'
import DashboardCompany from '../../../../../app/modules/profile/components-company/Dashboard'
import {Overview} from '../../../../../app/modules/profile/components/Overview'
import PersonalInformation from '../../../../../app/modules/profile/components/Personalnformation'
import Education from '../../../../../app/modules/profile/components/Education'
import Experience from '../../../../../app/modules/profile/components/Experience'
import Skill from '../../../../../app/modules/profile/components/Skill'
import Language from '../../../../../app/modules/profile/components/Language'
import ThesisDisertationProfile from '../../../../../app/modules/profile/components/ThesisDisertation'
import Other from '../../../../../app/modules/profile/components/Others'
import JobSearch from '../../../../../app/modules/profile/components/Jobs'
import MyApplicant from '../../../../../app/modules/profile/components/Jobs/MyApplicant'
import CompanySearch from '../../../../../app/modules/profile/components/CompanySearch'
import JobDetail from '../../../../../app/modules/profile/components/Jobs/Detail'
import DashboardAlumni from '../../../../../app/modules/profile/components/Dashboard'
// admin pages
import DashboardAdmin from '../../../../../app/modules/admin/Dashboard'
import Country from '../../../../../app/modules/admin/Country'
import Admin from '../../../../../app/modules/admin/Skill'
import Degree from '../../../../../app/modules/admin/Degree'
import WorkingType from '../../../../../app/modules/admin/WorkingType'
import {moduleAccess} from '../../../../../services/auth'
import Industry from '../../../../../app/modules/admin/Industry'
import Major from '../../../../../app/modules/admin/Major'
import LanguageAdmin from '../../../../../app/modules/admin/Language'
import City from '../../../../../app/modules/admin/City'
import Proficiency from '../../../../../app/modules/admin/Proficiency'
import Province from '../../../../../app/modules/admin/Province'
import Village from '../../../../../app/modules/admin/Village'
import Alumni from '../../../../../app/modules/admin/Alumni'
import Company from '../../../../../app/modules/admin/Company'
import Job from '../../../../../app/modules/admin/Job'
import CreateCompany from '../../../../../app/modules/admin/Company/Forms'
import VerificationCompany from '../../../../../app/modules/admin/Company/VerificationCompany'
import VerificationCompanyJob from '../../../../../app/modules/admin/Company/VerificationCompanyJob'
import UserVerification from '../../../../../app/modules/admin/User/UserVerification'
import User from '../../../../../app/modules/admin/User'
import Approval from '../../../../../app/modules/admin/Approval'
import Role from '../../../../../app/modules/admin/Role'
import NonAlumni from '../../../../../app/modules/admin/NonAlumni'
import JobLevel from '../../../../../app/modules/admin/JobLevel'
import University from '../../../../../app/modules/admin/University'
import MyProfile from '../../../../../app/modules/admin/MyProfile'
import CompanyListed from '../../../../../app/modules/admin/CompanyListed'
import {OverviewCompany} from '../../../../../app/modules/profile/components-company/Overview'
import VerificationJob from '../../../../../app/modules/admin/Job/VerificationJob'
import InformationCompany from '../../../../../app/modules/profile/components-company/Information'
import {CompanyJobList} from '../../../../../app/modules/profile/components-company/CompanyJobList'
import Log from '../../../../../app/modules/admin/Log'
import ReportAlumniProvince from '../../../../../app/modules/admin/Report/ReportAlumniProvince'
import ReportAlumniUniversity from '../../../../../app/modules/admin/Report/ReportAlumniUniversity'
import ReportAlumniOwnsership from '../../../../../app/modules/admin/Report/ReportAlumniOwnsership'
import District from '../../../../../app/modules/admin/District'
import ThesisDisertation from '../../../../../app/modules/admin/ThesisDisertation'
import ThesisDisertationContent from '../../../../../app/modules/admin/ThesisDisertationContent'
import CompanyOwnership from 'app/modules/admin/CompanyOwnership'
import Beranda from 'pana/pages/Beranda'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {useNavigate} from 'react-router-dom'
import MyPana from 'pana/pages/MyPana'
import Api from 'thesis-and-dissertations/helpers/api'

// PANA Pejuang Digital (merged to pana folder)
import PejuangPanduan from 'pana/pages/Panduan'
import PejuangMyPejuang from 'pana/pages/StatusPejuang'
import PejuangMonev from 'pana/pages/Monev'

// services

// CoP
import COPDashboard from 'app/modules/admin/Cop/Dashboard'
import COPBanner from 'app/modules/admin/Cop/Banners'
import COPCategoryNews from 'app/modules/admin/Cop/CategoryNews'
import COPBerita from 'app/modules/admin/Cop/News'
import COPVideo from 'app/modules/admin/Cop/Videos'

// PANA
import PanaRegistrationPeriod from '../../../../../app/modules/admin/PANA/RegistrationPeriod'
import Monitoring from '../../../../../app/modules/admin/PANA/Monitoring'
import AssignRole from '../../../../../app/modules/admin/PANA/AssignRole'
import AccountManagement from '../../../../../app/modules/admin/PANA/AccountManagement'
import IndicatorAssessment from '../../../../../app/modules/admin/PANA/IndicatorAssessment'
import LaporanKegiatanAdmin from '../../../../../app/modules/admin/PANA/LaporanKegiatan'
import AktivitasPenugasanAdmin from '../../../../../app/modules/admin/PANA/AktivitasPenugasan'
import ExcelManagementAdmin from '../../../../../app/modules/admin/PANA/ExcelManagement'
import BukuPanduanAdmin from '../../../../../app/modules/admin/PANA/BukuPanduan'
import MonitoringSP from '../../../../../app/modules/admin/PANA/MonitoringSP'

import Reviewer from '../../../../../app/modules/admin/PANA/Reviewer'
import ReviewerDetail from '../../../../../app/modules/admin/PANA/Reviewer/Detail'

import Assessment from '../../../../../app/modules/admin/PANA/Assessment'
import AssessmentDetail from '../../../../../app/modules/admin/PANA/Assessment/Detail'
import MonitoringProposal from '../../../../../app/modules/admin/PANA/Monitoring/Proposal'
import MonitoringInterview from '../../../../../app/modules/admin/PANA/Monitoring/Interview'

import PassingGrade from '../../../../../app/modules/admin/PANA/PassingGrade'
import Dashboard from 'app/modules/admin/PANA/Dashboard'
import ChangeStatus from 'app/modules/admin/PANA/ChangeStatus'
import Announcement from 'app/modules/admin/PANA/Announcement'
import Administration from 'app/modules/admin/PANA/Monitoring/Administration'
import AlumniProfile from 'app/modules/admin/AlumniProfile/Profile'
import PengajuanProfile from 'app/modules/admin/AlumniProfile/Pengajuan'
import AlumniSubmissions from 'app/modules/profile/components/AlumniSubmissions'

export const menusAlumniPana = [
  {
    name: 'Beranda',
    icon: '',
    path: '/pana-beranda',
    roles: ['admin'],
    access: [''],
    component: <Beranda />,
    child: [],
  },
  {
    name: 'Aplikasi PANA',
    icon: '',
    path: '/my-pana',
    roles: ['admin'],
    access: [''],
    component: <MyPana />,
    child: [],
  },
  {
    name: 'Panduan',
    icon: '',
    path: '/pejuang-panduan',
    roles: ['admin'],
    access: [''],
    component: <PejuangPanduan />,
    child: [],
  },
  {
    name: 'Status Saya',
    icon: '',
    path: '/my-pejuang',
    roles: ['admin'],
    access: [''],
    component: <PejuangMyPejuang />,
    child: [],
  },
  {
    name: 'Monev Mingguan',
    icon: '',
    path: '/pana-monev',
    roles: ['admin'],
    access: [''],
    component: <PejuangMonev />,
    child: [],
  },
  {
    name: 'Alumni',
    icon: '',
    path: '/alumni',
    roles: ['admin'],
    access: [''],
    component: null,
    child: [
      {
        name: 'Ringkasan',
        icon: '',
        path: 'crafted/pages/profile/basic-overview',
        roles: ['admin'],
        access: [''],
        component: <Overview />,
        child: [],
      },
      {
        name: 'Informasi Personal',
        icon: '',
        path: '/crafted/pages/profile/personal-information',
        roles: ['admin'],
        access: [''],
        component: <PersonalInformation />,
        child: [],
      },
      {
        name: 'Pendidikan',
        icon: '',
        path: '/crafted/pages/profile/education',
        roles: ['admin'],
        access: [''],
        component: <Education />,
        child: [],
      },
      {
        name: 'Pengalaman Kerja',
        icon: '',
        path: '/crafted/pages/profile/experience',
        roles: ['admin'],
        access: [''],
        component: <Experience />,
        child: [],
      },
      {
        name: 'Keahlian',
        icon: '',
        path: '/crafted/pages/profile/skill',
        roles: ['admin'],
        access: [''],
        component: <Skill />,
        child: [],
      },
      {
        name: 'Bahasa',
        icon: '',
        path: '/crafted/pages/profile/language',
        roles: ['admin'],
        access: [''],
        component: <Language />,
        child: [],
      },
      {
        name: 'Tesis & Disertasi',
        icon: '',
        path: '/crafted/pages/profile/thesis-and-disertation',
        roles: ['admin'],
        access: [''],
        component: <ThesisDisertationProfile />,
        child: [],
      },
      {
        name: 'Lainnya',
        icon: '',
        path: '/crafted/pages/profile/other',
        roles: ['admin'],
        access: [''],
        component: <Other />,
        child: [],
      },
    ],
  },
]

export const menusAlumniTalenta = [
  {
    name: 'Dashboard',
    icon: '',
    path: '/talenta-dashboard',
    roles: ['admin'],
    access: [''],
    component: <DashboardAlumni />,
    child: [],
  },
  {
    name: 'Alumni',
    icon: '',
    path: '/alumni',
    roles: ['admin'],
    access: [''],
    component: null,
    child: [
      {
        name: 'Ringkasan',
        icon: '',
        path: 'crafted/pages/profile/basic-overview',
        roles: ['admin'],
        access: [''],
        component: <Overview />,
        child: [],
      },
      {
        name: 'Informasi Personal',
        icon: '',
        path: '/crafted/pages/profile/personal-information',
        roles: ['admin'],
        access: [''],
        component: <PersonalInformation />,
        child: [],
      },
      {
        name: 'Pendidikan',
        icon: '',
        path: '/crafted/pages/profile/education',
        roles: ['admin'],
        access: [''],
        component: <Education />,
        child: [],
      },
      {
        name: 'Pengalaman Kerja',
        icon: '',
        path: '/crafted/pages/profile/experience',
        roles: ['admin'],
        access: [''],
        component: <Experience />,
        child: [],
      },
      {
        name: 'Keahlian',
        icon: '',
        path: '/crafted/pages/profile/skill',
        roles: ['admin'],
        access: [''],
        component: <Skill />,
        child: [],
      },
      {
        name: 'Bahasa',
        icon: '',
        path: '/crafted/pages/profile/language',
        roles: ['admin'],
        access: [''],
        component: <Language />,
        child: [],
      },
      {
        name: 'Tesis & Disertasi',
        icon: '',
        path: '/crafted/pages/profile/thesis-and-disertation',
        roles: ['admin'],
        access: [''],
        component: <ThesisDisertationProfile />,
        child: [],
      },
      {
        name: 'Lainnya',
        icon: '',
        path: '/crafted/pages/profile/other',
        roles: ['admin'],
        access: [''],
        component: <Other />,
        child: [],
      },
    ],
  },
  {
    name: 'Pekerjaan',
    icon: '',
    path: '#!',
    roles: ['admin'],
    access: [''],
    component: null,
    child: [
      {
        name: 'Lamaran Saya',
        icon: '',
        path: '/my-applicant',
        roles: ['admin'],
        access: [''],
        component: <MyApplicant />,
        child: [],
      },
      {
        name: 'Cari Lowongan Pekerjaan',
        icon: '',
        path: '/job-search',
        roles: ['admin'],
        access: [''],
        component: <JobSearch />,
        child: [],
      },
      {
        name: 'Cari Perusahaan',
        icon: '',
        path: '/company-search',
        roles: ['admin'],
        access: [''],
        component: <CompanySearch />,
        child: [],
      },
      {
        name: 'Detail Lowongan Pekerjaan',
        icon: '',
        path: '/job-search/:jobId',
        roles: ['admin'],
        access: [''],
        component: <JobDetail />,
        hideInSidebar: true,
      },
    ],
  },
  {
    name: 'Pengajuan Alumni',
    icon: '',
    path: '/pengajuan-alumni',
    roles: ['alumni'],
    access: [''],
    component: <AlumniSubmissions />,
    child: [],
  },
]

export const menusReviewer = [
  {
    title: 'Penilaian',
    icon: '',
    path: '/dashboard',
    roles: ['Reviewer_Administrasi_Pana'],
    access: [''],
    component: <Reviewer />,
    child: [],
  },
  {
    title: 'Detail Pendaftaran',
    icon: '',
    path: '/proposal/:id',
    roles: ['Reviewer_Administrasi_Pana'],
    access: [''],
    component: <ReviewerDetail />,
    child: [],
  },
]

export const menusAssessment = [
  {
    title: 'Penilaian',
    icon: '',
    path: '/dashboard',
    roles: ['Reviewer_Substansi_Pana', 'Reviewer_Proposal_Pana'],
    access: [''],
    component: <Assessment />,
    child: [],
  },
  {
    title: 'Detail Proposal',
    icon: '',
    path: '/proposal/:proposalId',
    roles: ['Reviewer_Substansi_Pana', 'Reviewer_Proposal_Pana'],
    access: [''],
    component: <AssessmentDetail />,
    child: [],
  },
  {
    title: 'Detail Wawancara',
    icon: '',
    path: '/wawancara/:interviewId',
    roles: ['Reviewer_Substansi_Pana', 'Reviewer_Proposal_Pana'],
    access: [''],
    component: <AssessmentDetail />,
    child: [],
  },
]

export const menusMitraProgramPANA = [
  {
    name: 'Laporan Kegiatan',
    icon: '',
    path: '/laporan-kegiatan-admin',
    roles: ['Mitra_Program_PANA'],
    access: [''],
    component: <LaporanKegiatanAdmin />,
    child: [],
  },
  {
    name: 'Monitoring',
    icon: '',
    path: '/monitoring',
    roles: ['Mitra_Program_PANA'],
    access: [''],
    component: <Monitoring />,
    child: [],
  },
  {
    name: 'Monitoring Detail Proposal',
    icon: '',
    path: '/monitoring/proposal/:id',
    roles: ['Mitra_Program_PANA'],
    access: [''],
    component: <MonitoringProposal />,
    child: [],
    hideInSidebar: true,
  },
  {
    name: 'Monitoring Detail Interview',
    icon: '',
    path: '/monitoring/interview/:id',
    roles: ['Mitra_Program_PANA'],
    access: [''],
    component: <MonitoringInterview />,
    child: [],
    hideInSidebar: true,
  },
  {
    name: 'Monitoring Detail Administration',
    icon: '',
    path: '/monitoring/administration/:id',
    roles: ['Mitra_Program_PANA'],
    access: [''],
    component: <Administration />,
    child: [],
    hideInSidebar: true,
  },
]

export const menusAdditionalAlumni = [
  {
    title: 'Informasi',
    icon: '',
    path: '/crafted/pages/profile/company-overview',
    roles: ['company'],
    access: [''],
    component: <OverviewCompany />,
    child: [],
  },
  {
    title: 'Pekerjaan',
    icon: '',
    path: '/crafted/pages/profile/company-job',
    roles: ['company'],
    access: [''],
    component: <CompanyJobList />,
    child: [],
  },
]

export const menusCompany = [
  {
    name: 'Dashboard',
    icon: '',
    path: '/dashboard',
    roles: ['company'],
    access: [''],
    component: <DashboardCompany />,
    child: [],
  },
  {
    name: 'Perusahaan',
    icon: '',
    path: '',
    roles: ['company'],
    access: [''],
    component: null,
    child: [
      {
        name: 'Informasi',
        icon: '',
        path: '/crafted/pages/profile/company-overview',
        roles: ['company'],
        access: [''],
        component: <OverviewCompany />,
        child: [],
      },
      {
        name: 'Edit Informasi Perusahaan',
        icon: '',
        path: '/crafted/pages/profile/company/information',
        roles: ['company'],
        access: [''],
        component: <InformationCompany />,
        child: [],
      },
      // {
      //   name: 'Pekerjaan',
      //   icon: '',
      //   path: '/crafted/pages/profile/company-job',
      //   roles: ['company'],
      //   access: [''],
      //   component: <CompanyJobList />,
      //   child: [],
      // },
    ],
  },
  {
    name: 'Lowongan kerja',
    icon: '',
    path: '/jobs',
    roles: ['company'],
    access: [''],
    component: null,
    child: [
      {
        name: 'Semua Lowongan Saya',
        icon: '',
        path: '/list-job',
        roles: ['company'],
        access: [''],
        component: <Jobs />,
        child: [],
      },
      {
        name: 'Buka Lowongan',
        icon: '',
        path: '/create-job',
        roles: ['company'],
        access: [''],
        component: <CreateJob />,
        child: [],
      },
      {
        name: 'Pelamar Pekerjaan',
        icon: '',
        path: '/applicants-job/:jobId',
        roles: ['company'],
        access: [''],
        component: <Applicants />,
        hideInSidebar: true,
      },
    ],
  },
  // {
  //   name: 'Panduan',
  //   icon: '',
  //   path: '/tutorial',
  //   roles: ['company'],
  //   access: [''],
  //   component: <DashboardWrapper />,
  //   child: [],
  // },
]

export const menusAdminVT= [
  {
    name: 'Dashboard',
    icon: '',
    path: '/dashboard',
    roles: ['admin'],
    access: [''],
    component: <DashboardAdmin />,
    child: [],
  },
  // CoP menus
  {
    name: 'CoP',
    icon: '',
    path: '/alumni',
    roles: ['admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Dashboard',
        icon: '',
        path: '/cop-dashboard',
        roles: ['admin'],
        access: [''],
        component: <COPDashboard />,
        child: [],
      },
      {
        name: 'Banner',
        icon: '',
        path: '/cop-banner',
        roles: ['admin'],
        access: [''],
        component: <COPBanner />,
        child: [],
      },
      {
        name: 'Kategori Berita',
        icon: '',
        path: '/cop-categories',
        roles: ['admin'],
        access: [''],
        component: <COPCategoryNews />,
        child: [],
      },
      {
        name: 'List Berita',
        icon: '',
        path: '/cop-news',
        roles: ['admin'],
        access: [''],
        component: <COPBerita />,
        child: [],
      },
      {
        name: 'Video (Youtube)',
        icon: '',
        path: '/cop-videos',
        roles: ['admin'],
        access: [''],
        component: <COPVideo />,
        child: [],
      },
    ],
  },
  // Pengajuan Alumni Menus
  {
    name: 'Profil Alumni',
    icon: '',
    path: '/profil-alumni',
    roles: ['company', 'admin', 'section-head', 'BPK'],
    access: [''],
    component: <AlumniProfile />,
    child: [],
  },
  {
    name: 'Pengajuan Alumni',
    icon: '',
    path: '/pengajuan-alumni',
    roles: ['company', 'admin', 'section-head', 'BPK'],
    access: [''],
    component: <PengajuanProfile />,
    child: [],
  },
]

export const menusAdmin = [
  {
    name: 'Dashboard',
    icon: '',
    path: '/dashboard',
    roles: ['company', 'admin', 'section-head', 'BPK'],
    access: [''],
    component: <DashboardAdmin />,
    child: [],
  },
  {
    name: 'Master Data General',
    icon: '',
    path: 'masterdata',
    roles: ['company', 'admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Negara',
        icon: '',
        path: '/country',
        roles: ['company', 'admin'],
        access: [''],
        component: <Country />,
        child: [],
      },
      {
        name: 'Provinsi',
        icon: '',
        path: '/province',
        roles: ['company', 'admin'],
        access: [''],
        component: <Province />,
        child: [],
      },
      {
        name: 'Kota',
        icon: '',
        path: '/city',
        roles: ['company', 'admin'],
        access: [''],
        component: <City />,
        child: [],
      },
      {
        name: 'Kecamatan',
        icon: '',
        path: '/district',
        roles: ['company', 'admin'],
        access: [''],
        component: <District />,
        child: [],
      },
      {
        name: 'Desa',
        icon: '',
        path: '/village',
        roles: ['company', 'admin'],
        access: [''],
        component: <Village />,
        child: [],
      },
      {
        name: 'Bahasa',
        icon: '',
        path: '/language',
        roles: ['company', 'admin'],
        access: [''],
        component: <LanguageAdmin />,
        child: [],
      },
    ],
  },
  {
    name: 'Master Data Pekerjaan',
    icon: '',
    path: 'masterdata.pekerjaan',
    roles: ['company', 'admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Data Perusahaan',
        icon: '',
        path: '/all-company-listed',
        roles: ['company', 'admin'],
        access: [''],
        component: <CompanyListed />,
        child: [],
      },
      {
        name: 'Kepemilikan Perusahaan',
        icon: '',
        path: '/company-ownership',
        roles: ['admin'],
        access: [''],
        component: <CompanyOwnership />,
        child: [],
      },
      {
        name: 'Jenis Industri',
        icon: '',
        path: '/industry',
        roles: ['company', 'admin'],
        access: [''],
        component: <Industry />,
        child: [],
      },
      {
        name: 'Jenis Pekerjaan',
        icon: '',
        path: '/working-type',
        roles: ['company', 'admin'],
        access: [''],
        component: <WorkingType />,
        child: [],
      },
      {
        name: 'Job Level',
        icon: '',
        path: '/job-level',
        roles: ['company', 'admin'],
        access: [''],
        component: <JobLevel />,
        child: [],
      },
      {
        name: 'Keahlian',
        icon: '',
        path: '/skill',
        roles: ['company', 'admin'],
        access: [''],
        component: <Admin />,
        child: [],
      },
      {
        name: 'Tingkat Kemahiran',
        icon: '',
        path: '/proficiency',
        roles: ['company', 'admin'],
        access: [''],
        component: <Proficiency />,
        child: [],
      },
    ],
  },
  {
    name: 'Master Data Pendidikan',
    icon: '',
    path: 'masterdata.Pendidikan',
    roles: ['company', 'admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Perguruan Tinggi',
        icon: '',
        path: '/university',
        roles: ['company', 'admin'],
        access: [''],
        component: <University />,
        child: [],
      },
      {
        name: 'Jurusan',
        icon: '',
        path: '/jurusan',
        roles: ['company', 'admin'],
        access: [''],
        component: <Major />,
        child: [],
      },
      {
        name: 'Jenjang Pendidikan',
        icon: '',
        path: '/degree',
        roles: ['company', 'admin'],
        access: [''],
        component: <Degree />,
        child: [],
      },
    ],
  },

  {
    name: 'Perusahaan Terdaftar',
    icon: '',
    path: 'perusaahaan',
    roles: ['company', 'admin', 'section-head', 'BPK'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Semua Perusahaan',
        icon: '',
        path: '/all-company',
        roles: ['company', 'admin'],
        access: [''],
        component: <Company />,
        child: [],
      },
      {
        name: 'Verifikasi Perusahaan',
        icon: '',
        path: '/verification-company',
        roles: ['company', 'admin'],
        access: [''],
        component: <VerificationCompany />,
        child: [],
      },
      // {
      //   name: 'Tambah Perusahaan',
      //   icon: '',
      //   path: '/create-company',
      //   roles: ['company', 'admin'],
      //   access: [''],
      //   component: <CreateCompany />,
      //   child: [],
      // },
    ],
  },
  {
    name: 'Lowongan Kerja',
    icon: '',
    path: 'lowongankerja',
    roles: ['company', 'admin', 'section-head', 'BPK'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Semua Lowongan',
        icon: '',
        path: '/all-jobs',
        roles: ['company', 'admin'],
        access: [''],
        component: <Job />,
        child: [],
      },
      {
        name: 'Verifikasi Lowongan',
        icon: '',
        path: '/verification-jobs',
        roles: ['company', 'admin'],
        access: [''],
        component: <VerificationCompanyJob />,
        child: [],
      },
      // {
      //   name: 'Verifikasi Lowongan',
      //   icon: '',
      //   path: '/create-jobs',
      //   roles: ['company', 'admin'],
      //   access: [''],
      //   component: <CreateJob />,
      //   child: [],
      // },
    ],
  },
  {
    name: 'Alumni',
    icon: '',
    path: '/alumni',
    roles: ['company', 'admin', 'section-head'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Semua Alumni',
        icon: '',
        path: '/all-user',
        roles: ['company', 'admin'],
        access: [''],
        component: <User />,
        child: [],
      },
      {
        name: 'Verifikasi Alumni',
        icon: '',
        path: '/verification-user',
        roles: ['company', 'admin'],
        access: [''],
        component: <UserVerification />,
        child: [],
      },
      // {
      //   name: 'Tambah Alumni',
      //   icon: '',
      //   path: '/create-user',
      //   roles: ['company', 'admin'],
      //   access: [''],
      //   component: <CreateCompany />,
      //   child: [],
      // },
    ],
  },
  {
    name: 'Akun',
    icon: '',
    path: 'akun',
    roles: ['company', 'admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Akun Saya',
        icon: '',
        path: '/my-account',
        roles: ['company', 'admin'],
        access: [''],
        component: <MyProfile />,
        child: [],
      },
      {
        name: 'List Admin',
        icon: '',
        path: 'list-admin',
        roles: ['company', 'admin'],
        access: [''],
        component: <NonAlumni />,
        child: [],
      },
      {
        name: 'Role Management',
        icon: '',
        path: 'role-management',
        roles: ['company', 'admin'],
        access: [''],
        component: <Role />,
        child: [],
      },
      {
        name: 'Setting Approval User Level',
        icon: '',
        path: 'approval-management',
        roles: ['company', 'admin'],
        access: [''],
        component: <Approval />,
        child: [],
      },
    ],
  },
  {
    name: 'Log',
    icon: '',
    path: '/log',
    roles: ['admin'],
    access: [''],
    component: <Log />,
    child: [],
  },
  {
    name: 'Report',
    icon: '',
    path: '/alumni',
    roles: ['admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Alumni - Provinsi',
        icon: '',
        path: '/report-provinsi',
        roles: ['admin'],
        access: [''],
        component: <ReportAlumniProvince />,
        child: [],
      },
      {
        name: 'Alumni - Universitas',
        icon: '',
        path: '/report-university',
        roles: ['admin'],
        access: [''],
        component: <ReportAlumniUniversity />,
        child: [],
      },
      {
        name: 'Alumni - Tipe Perusahaan',
        icon: '',
        path: '/report-ownership',
        roles: ['admin'],
        access: [''],
        component: <ReportAlumniOwnsership />,
        child: [],
      },
    ],
  },
  {
    name: 'Tesis & Disertasi',
    icon: '',
    path: '/alumni',
    roles: ['admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Konten Tesis & Disertasi',
        icon: '',
        path: '/content-thesis-disertation',
        roles: ['admin'],
        access: [''],
        component: <ThesisDisertationContent />,
        child: [],
      },
      {
        name: 'Daftar Tesis & Disertasi',
        icon: '',
        path: '/thesis-disertation',
        roles: ['admin'],
        access: [''],
        component: <ThesisDisertation />,
        child: [],
      },
    ],
  },
  {
    name: 'Pana',
    icon: '',
    path: '/alumni',
    roles: ['admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      // {
      //   name: 'Dashboard',
      //   icon: '',
      //   path: '/dashboard-pana',
      //   roles: ['admin'],
      //   access: [''],
      //   component: <Dashboard />,
      //   child: [],
      // },
      {
        name: 'Periode Registrasi PANA',
        icon: '',
        path: '/registration-period',
        roles: ['admin'],
        access: [''],
        component: <PanaRegistrationPeriod />,
        child: [],
      },
      {
        name: 'Assign Role',
        icon: '',
        path: '/assign-role',
        roles: ['admin'],
        access: [''],
        component: <AssignRole />,
        child: [],
      },
      {
        name: 'Manajemen Akun',
        icon: '',
        path: '/account-management',
        roles: ['admin'],
        access: [''],
        component: <AccountManagement />,
        child: [],
      },
      {
        name: 'Monitoring Super Admin',
        icon: '',
        path: '/monitoring',
        roles: ['admin'],
        access: [''],
        component: <Monitoring />,
        child: [],
      },
      {
        name: 'Monitoring Super Admin',
        icon: '',
        path: '/monitoring/proposal/:id',
        roles: ['admin'],
        access: [''],
        component: <MonitoringProposal />,
        child: [],
        hideInSidebar: true,
      },
      {
        name: 'Monitoring Super Admin',
        icon: '',
        path: '/monitoring/interview/:id',
        roles: ['admin'],
        access: [''],
        component: <MonitoringInterview />,
        child: [],
        hideInSidebar: true,
      },
      {
        name: 'Monitoring Super Admin',
        icon: '',
        path: '/monitoring/administration/:id',
        roles: ['admin'],
        access: [''],
        component: <Administration />,
        child: [],
        hideInSidebar: true,
      },
      {
        name: 'Monitoring SP',
        icon: '',
        path: '/pana-monitoring-sp',
        roles: ['admin'],
        access: [''],
        component: <MonitoringSP />,
        child: [],
      },
      {
        name: 'Indikator Penilaian',
        icon: '',
        path: '/indicator-assessment',
        roles: ['admin'],
        access: [''],
        component: <IndicatorAssessment />,
        child: [],
      },
      {
        name: 'Laporan Kegiatan',
        icon: '',
        path: '/laporan-kegiatan-admin',
        roles: ['admin'],
        access: [''],
        component: <LaporanKegiatanAdmin />,
        child: [],
      },
      {
        name: 'Aktivitas Penugasan',
        icon: '',
        path: '/aktivitas-penugasan-admin',
        roles: ['admin'],
        access: [''],
        component: <AktivitasPenugasanAdmin />,
        child: [],
      },
      {
        name: 'Kelola Excel',
        icon: '',
        path: '/excel-management-admin',
        roles: ['admin'],
        access: [''],
        component: <ExcelManagementAdmin />,
        child: [],
      },
      {
        name: 'Kelola Buku Panduan',
        icon: '',
        path: '/buku-panduan-admin',
        roles: ['admin'],
        access: [''],
        component: <BukuPanduanAdmin />,
        child: [],
      },
      // {
      //   name: 'Passing Grade',
      //   icon: '',
      //   path: '/passing-grade',
      //   roles: ['admin'],
      //   access: [''],
      //   component: <PassingGrade />,
      //   child: [],
      // },
      // {
      //   name: 'Pengumuman',
      //   icon: '',
      //   path: '/announcement',
      //   roles: ['admin'],
      //   access: [''],
      //   component: <Announcement />,
      //   child: [],
      // },
      {
        name: 'Ubah Status',
        icon: '',
        path: '/change-status',
        roles: ['admin'],
        access: [''],
        component: <ChangeStatus />,
        child: [],
      },
    ],
  },
  // CoP menus
  {
    name: 'Berita dan CoP',
    icon: '',
    path: '/alumni',
    roles: ['admin'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Dashboard',
        icon: '',
        path: '/cop-dashboard',
        roles: ['admin'],
        access: [''],
        component: <COPDashboard />,
        child: [],
      },
      {
        name: 'Banner',
        icon: '',
        path: '/cop-banner',
        roles: ['admin'],
        access: [''],
        component: <COPBanner />,
        child: [],
      },
      {
        name: 'Kategori Berita',
        icon: '',
        path: '/cop-categories',
        roles: ['admin'],
        access: [''],
        component: <COPCategoryNews />,
        child: [],
      },
      {
        name: 'List Berita',
        icon: '',
        path: '/cop-news',
        roles: ['admin'],
        access: [''],
        component: <COPBerita />,
        child: [],
      },
      {
        name: 'Video (Youtube)',
        icon: '',
        path: '/cop-videos',
        roles: ['admin'],
        access: [''],
        component: <COPVideo />,
        child: [],
      },
    ],
  },
  {
    name: 'Profil Alumni',
    icon: '',
    path: '/profil-alumni',
    roles: ['company', 'admin', 'section-head', 'BPK'],
    access: [''],
    component: <DashboardWrapper />,
    child: [
      {
        name: 'Monitoring Profil Alumni',
        icon: '',
        path: '/monitoring-profil-alumni',
        roles: ['company', 'admin', 'section-head', 'BPK'],
        access: [''],
        component: <AlumniProfile />,
        child: [],
      },
      {
        name: 'Monitoring Pengajuan',
        icon: '',
        path: '/monitoring-pengajuan',
        roles: ['company', 'admin', 'section-head', 'BPK'],
        access: [''],
        component: <PengajuanProfile />,
        child: [],
      },
    ],
  },
  // {
  //   name: 'Approval User Level',
  //   icon: '',
  //   path: 'lowongankerja',
  //   roles: ['company', 'admin'],
  //   access: [''],
  //   component: <DashboardWrapper />,
  //   child: [
  //     {
  //       name: 'Registrasi Perusahaan',
  //       icon: '',
  //       path: '/all-jobs',
  //       roles: ['company', 'admin'],
  //       access: [''],
  //       component: <Job />,
  //       child: [],
  //     },
  //     {
  //       name: 'Verifikasi Lowongan',
  //       icon: '',
  //       path: '/verification-jobs',
  //       roles: ['company', 'admin'],
  //       access: [''],
  //       component: <VerificationCompany />,
  //       child: [],
  //     },
  //     {
  //       name: 'Tambah Lowongan',
  //       icon: '',
  //       path: '/create-jobs',
  //       roles: ['company', 'admin'],
  //       access: [''],
  //       component: <CreateJob />,
  //       child: [],
  //     },
  //   ],
  // },
]

const SidebarMenuMain = () => {
  const navigate = useNavigate()
  const intl = useIntl()
  const [finalMenu, setFinalMenu] = useState<any>([])
  const [statusPenilaian, setStatusPenilaian] = useState<string | null>(null)
  const role = localStorage.getItem('role')
  const keyRole = localStorage.getItem('keyRole')
  const alumniPage = localStorage.getItem('alumniPage')

  const menuSectionHead = menusAdmin.filter((f: any) => f.roles?.includes('section-head'))
  const menuBPK = menusAdmin.filter((f: any) => f.roles?.includes('BPK'))

  useEffect(() => {
    getModuleAccess()
    fetchStatusPenilaian()
  }, [])

  useEffect(() => {
    let menu = getMenu()
    setFinalMenu(menu)
  }, [statusPenilaian])

  const getMenu = () => {
    let baseMenu: any[] = []
    
    if (role == 'company') baseMenu = menusCompany
    else if (role == 'Alumni') {
      baseMenu = alumniPage == 'pana' ? menusAlumniPana : menusAlumniTalenta
    }
    else if (role == 'Super_Admin' && !keyRole) baseMenu = menusAdmin // change this to menusAdmin if needed
    else if (keyRole == 'Section_Head') baseMenu = menuSectionHead
    else if (keyRole == 'BPK') baseMenu = menuBPK
    else if (role == 'Reviewer_Administrasi_Pana') baseMenu = menusReviewer
    else if (role == 'Reviewer_Substansi_Pana' || role == 'Reviewer_Proposal_Pana') baseMenu = menusAssessment
    else if (role == 'Mitra_Program_PANA') baseMenu = menusMitraProgramPANA
    
    // Filter menu Monev jika status_penilaian bukan "Lolos"
    if (alumniPage == 'pana' && statusPenilaian !== 'Lolos') {
      baseMenu = baseMenu.filter((menu: any) => menu.path !== '/pana-monev')
    }
    
    return baseMenu
  }

  const fetchStatusPenilaian = async () => {
    // Hanya fetch jika user adalah Alumni PANA
    if (role !== 'Alumni' || alumniPage !== 'pana') {
      return
    }
    
    try {
      const api = new Api()
      const response: any = await api.getRegisterPana()
      const panaData = response?.data?.data
      setStatusPenilaian(panaData?.status_penilaian || null)
    } catch (error) {
      // Jika error, set null (menu Monev tidak akan ditampilkan)
      setStatusPenilaian(null)
    }
  }

  const getModuleAccess = async () => {
    try {
      const res = await moduleAccess()
    } catch (error) {
      handleApiError(error, navigate)
    }
  }

  return (
    <>
      {finalMenu?.map((item: any, key: any) => {
        if (item?.hideInSidebar === true) return null
        if (item.child.length === 0) {
          return (
            <SidebarMenuItem
              to={item.path}
              // icon='/media/icons/duotune/art/art002.svg'
              title={item.name}
              fontIcon='bi-app-indicator'
              key={key}
            />
          )
        } else {
          return (
            <SidebarMenuItemWithSub
              to={item.path}
              title={item.name}
              fontIcon='bi-archive'
              key={key}
              // icon='/media/icons/duotune/general/gen022.svg'
            >
              {item.child.map((item2: any, key2: any) => {
                return (
                  item2?.hideInSidebar !== true && (
                    <SidebarMenuItem
                      to={item2.path}
                      title={item2.name}
                      // hasBullet={true}
                      key={`${key}-${key2}`}
                    />
                  )
                )
              })}
            </SidebarMenuItemWithSub>
          )
        }
      })}
    </>
  )
}

export {SidebarMenuMain}
